// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-chronik-tsx": () => import("./../../../src/pages/chronik.tsx" /* webpackChunkName: "component---src-pages-chronik-tsx" */),
  "component---src-pages-datenschutz-tsx": () => import("./../../../src/pages/datenschutz.tsx" /* webpackChunkName: "component---src-pages-datenschutz-tsx" */),
  "component---src-pages-impressum-tsx": () => import("./../../../src/pages/impressum.tsx" /* webpackChunkName: "component---src-pages-impressum-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-kontakt-tsx": () => import("./../../../src/pages/kontakt.tsx" /* webpackChunkName: "component---src-pages-kontakt-tsx" */),
  "component---src-pages-mitgliedschaft-tsx": () => import("./../../../src/pages/mitgliedschaft.tsx" /* webpackChunkName: "component---src-pages-mitgliedschaft-tsx" */),
  "component---src-pages-verein-tsx": () => import("./../../../src/pages/verein.tsx" /* webpackChunkName: "component---src-pages-verein-tsx" */)
}

